// RITA-1504 (Nutzungserfassung Phase 2b) — Kopfsuche: Filter und Rang (Entwurf D).
//
// Bisher filterte das Autocomplete mit seinem eingebauten Filter. Die Erfassung braucht aber
// genau die Liste, die der Bedienende sieht: die Trefferzahl und die Position des gewählten
// Treffers. Ein zweiter, eigener Filter ließe Anzeige und Meldung auseinanderlaufen — deshalb
// steht der eine Filter hier und wird dem Autocomplete als `filterOptions` übergeben.
//
// Das Verhalten bleibt unverändert: createFilterOptions mit derselben Beschriftung wie bisher
// (getOptionLabel) und den MUI-Voreinstellungen — Groß-/Kleinschreibung und Akzente werden
// ignoriert, der Suchtext darf an beliebiger Stelle stehen.
//
// Hier steht nur das Suchen und Zählen; gemeldet wird in Searchbar.tsx, und zwar ausschließlich
// über describeSearch (Länge, Trefferzahl, Rang). Suchtext und Beraterdaten verlassen dieses
// Modul nie.
import { createFilterOptions } from '@mui/material';
import type { FilterOptionsState } from '@mui/material';
import { Agent } from '../../../types/Agent.types';

/** Beschriftung eines Treffers: Beraternummer, Nachname, Vorname (unverändert). */
export const searchbarOptionLabel = (option: Agent): string => `${option.agent_id} ${option.surname} ${option.name}`;

/** Der eine Filter der Kopfsuche — er liefert genau die angezeigte Trefferliste. */
export const filterSearchbarOptions: (options: Agent[], state: FilterOptionsState<Agent>) => Agent[] =
  createFilterOptions<Agent>({ stringify: searchbarOptionLabel });

/**
 * 1-basierte Position eines gewählten Treffers in der angezeigten Liste. Ohne Auswahl — oder
 * wenn der Treffer nicht in der Liste steht — kommt undefined zurück; dann entfällt
 * selected_rank, statt eine 0 zu melden, die es als Rang nicht gibt.
 */
export const searchbarRank = (options: readonly Agent[], selected: Agent | null | undefined): number | undefined => {
  if (!selected) return undefined;
  const index = options.indexOf(selected);
  return index >= 0 ? index + 1 : undefined;
};
